export default __webpack_public_path__ + "static/media/product-13 (2).64e9b7ed.jpg";